import { Skeleton } from '@monksflow/monks-ui';

/**
 * Placeholder rows shown while a thread's replies load after the card opens.
 * Mirrors the reply row layout (indented avatar + name + body line) so the swap
 * to real replies doesn't shift the thread.
 */
export function CommentRepliesSkeleton() {
  return (
    <div data-testid="comment-replies-skeleton" aria-busy="true" aria-live="polite">
      {Array.from({ length: 2 }).map((_, index) => (
        <div key={index} className="ml-7 flex gap-3 py-2">
          <Skeleton className="mt-1 size-7 shrink-0 rounded-full" />
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-3 w-4/5" />
          </div>
        </div>
      ))}
    </div>
  );
}
